import { computed, Directive, Signal } from '@angular/core';
import { LinkItemModel } from '@libs/cms/models';
import { TargetType } from '@libs/shared/models';
import { LinkDirective } from './link.directive';

@Directive({
  selector: 'a[uiContentLink]',
})
export class ContentLinkDirective extends LinkDirective<LinkItemModel> {
  public override target: Signal<TargetType> = computed(() => {
    return this.link().target;
  });

  protected override getRawHref(link: LinkItemModel): string {
    return link.href;
  }
}
